import React, { useEffect, useState } from "react";
import { Rate } from "antd";
import { getDefaultComponentStyle } from "./utils/defaultStyles";

export default ({
  data,
  getText,
  setRetrieveValues,
}: {
  data: IMultiElementCombineMsg.IRateElem;
  getText: (text: IMultiElementCombineMsg.IText) => string;
  setRetrieveValues: (value: IMultiElementCombineMsg.IRetrieveValues) => void;
}) => {
  const { id, type, title, isRequire, value, disable } = data;

  const [rateValue, setRateValue] = useState<number>(value);
  const style = getDefaultComponentStyle(data);

  useEffect(() => {
    setRateValue(value);
  }, [value]);

  const titleStr = getText(title);

  const changeHandle = (value: number) => {
    setRateValue(value);
    setRetrieveValues({ id, type, value });
  };
  return (
    <div className={"sscard-rateBox"} style={style}>
      {titleStr ? (
        <div className={`${"rateTitle"} ${isRequire ? "isRequire" : ""}`}>
          {titleStr}
        </div>
      ) : null}
      <div className={"rateContent"} onClick={(e) => e?.stopPropagation()}>
        <Rate
          value={rateValue}
          allowClear={false}
          disabled={Boolean(disable)}
          style={{ color: "#FB9C00", fontSize: "24px", lineHeight: 1 }}
          onChange={changeHandle}
        />
      </div>
    </div>
  );
};
